import type { App } from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

/**
 * Notification provider configuration
 * Uses VueSweetalert2 for displaying alert/confirmation dialogs
 */
export function setupNotifications(app: App) {
  app.use(VueSweetalert2);
}

